import Axios from "axios";
import { Toast } from "vant";
import error from "../utils/error";
import store from "@/store";

const axios = Axios.create({
  // baseURL: '',
  // timeout: 6 * 1000
  baseURL: process.env.VUE_APP_API_BASE_URL || "/api",
});
//全局loading
let loading;
let loadingflag;
let needLoadingRequestCount = 0; // 当前正在请求的数量

export function startLoading() {
  if (needLoadingRequestCount === 0) {
    loading = Toast.loading({
      duration: 0,
      message: "加载中...",
      // overlay:true,
      forbidClick: true,
    });
  }
  needLoadingRequestCount++;
}

export function endLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0 && loading) {
    loading.clear();
  }
}

const loadingNone = ["/admin-api/patrol/deploy-report/getReportById"];
//请求拦截
axios.interceptors.request.use(
  function (config) {
    let loadingNoneItem = config.url.split("?")[0];
    const userToken = JSON.parse(window.localStorage.getItem("AndroidToken"));
    loadingflag = store.state.dailycheck.loadingflag;
    if (loadingflag) {
      loadingNone.forEach((item) => {
        if (item != loadingNoneItem) {
          startLoading();
        }
      });
    } else store.commit("dailycheck/ALTER_LOADINGFLAG", 1);
    if (userToken) {
      let USERTOKRN = userToken.Bearer;
      let USERtenantID = userToken.tenant_id;
      config.headers.Authorization = "Bearer " + USERTOKRN || "";
      config.headers["tenant-id"] = USERtenantID;
      localStorage.setItem("tenant", USERtenantID);
    } else {
      config.headers.Authorization =
        "Bearer " + window.localStorage.getItem("CT_APP_TOKEN") || "";
      // 使用环境变量配置的租户ID
      // 可在 .env.development 文件中修改 VUE_APP_TENANT_ID
      config.headers["tenant-id"] = process.env.VUE_APP_TENANT_ID;
      localStorage.setItem("tenant", process.env.VUE_APP_TENANT_ID);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
//响应拦截
axios.interceptors.response.use(
  function (response) {
    // 未设置状态码则默认成功状态
    const code = response.data.code || 0;
    // 获取错误信息
    const msg = error[code] || response.data.msg || error["default"];
    if (code != 0) {
      // Toast(msg)
      endLoading();
      return response;
    } else {
      loadingflag = store.state.dailycheck.loadingflag;
      if (loadingflag) {
        endLoading();
      }
      return response;
    }
  },
  function (error) {
    endLoading();
    // Toast.fail('加载失败,请联系管理员');
    return Promise.reject(error);
  }
);
export { axios };
export default (url, method = "get", data = {}, getIt = false) => {
  if (getIt) {
    return axios({
      url,
      method,
      params: data,
    });
  }
  return axios({
    url,
    method,
    data,
  });
};
